import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rep, (n) => {
    return (_openBlock(), _createBlock(_Transition, {
      key: n,
      name: "skeleton",
      mode: "out-in",
      css: $props.transition ? true : false
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass([_ctx.$attrs.class, $options.componentClass])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["css"]))
  }), 128))
}